export default __webpack_public_path__ + "static/media/linkdinIcon.918c42fd.svg";